<template>
  <section class="matrix__wrapper">
    <div class="ws-textbox">
      <table class="matrix-table mx-auto my-auto table-responsive">
        <thead>
          <tr>
            <td></td>
            <td v-for="n in number" :key="n" class="padding-td" align="center">
              {{ n }}
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(pax, index) in listPax" :key="index">
            <td class="pax-fullname">
              {{ pax.first_name + ' ' + pax.last_name }}
            </td>
            <td v-for="n in number" :key="n" align="center" class="padding-td">
              <input
                type="radio"
                :disabled="isAirlineSet"
                :name="'room-' + pax.passenger_id"
                :checked="dataSelect[index] === n"
                :value="n"
                @change="handleSelectMatrix(index, $event)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MatrixSelect',
  props: {
    listPax: {
      type: Array,
      default: () => []
    },
    number: {
      type: Number,
      default: 1
    },
    isAirlineSet: {
      type: Boolean,
      default: false
    },
    airlineMatrix: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dataSelect: []
    }
  },
  watch: {
    listPax() {
      if (!this.isDefaultValue) {
        this.autoSetMatrix()
      }
    },
    number() {
      this.autoSetMatrix()
    },
    airlineMatrix() {
      this.dataSelect = this.airlineMatrix
    }
  },
  beforeMount() {
    if (!this.airlineMatrix.length) {
      this.autoSetMatrix()
    } else {
      this.dataSelect = this.airlineMatrix
      this.$emit('getListSelected', this.dataSelect)
    }
  },
  methods: {
    // paint diagonal line in matrix
    autoSetMatrix() {
      let self = this
      if (!this.listPax.length) {
        return
      }
      for (let index = 0; index < this.listPax.length; index++) {
        // check index = 0
        if (!index) {
          this.$set(this.dataSelect, index, index + 1)
          continue
        }
        this.$set(this.dataSelect, index, this.dataSelect[index - 1] + 1)
        // check dataSelect before >= number -> if true come back assign 1
        if (this.dataSelect[index - 1] >= this.number) {
          this.$set(this.dataSelect, index, 1)
        }
      }
      this.$emit('getListSelected', this.dataSelect)
    },

    handleSelectMatrix(index, e) {
      this.$set(this.dataSelect, index, +e.target.value)
      this.$emit('getListSelected', this.dataSelect)
    }
  }
}
</script>

<style lang="scss" scoped>
.matrix {
  &__wrapper {
    input[type='radio']:checked {
      box-shadow: 0 0 0 2px #00c365;
    }

    input[type='radio']:before {
      content: '';
      display: block;
      width: 60%;
      height: 60%;
      margin: 20% auto;
      border-radius: 50%;
    }

    input[type='radio']:checked:before {
      background: #00c365;
    }
  }

  &-table {
    font-size: 16px;
    border-collapse: inherit;

    .padding-td {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }

    .pax-fullname {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      width: 170px;
    }
  }

  &-name ::v-deep {
    width: 150px;
  }
}

input[type='radio'] {
  -webkit-appearance: none;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  outline: none;
  box-shadow: 0 0 0 2px gray;
}
</style>
